/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Where should the `buyToken` be transferred to?
 */
export enum BuyTokenDestination {
    ERC20 = 'erc20',
    INTERNAL = 'internal',
}
